import { API_URLS } from "../../constants/api/index.js"
async function CaptchaCallService() {

   let responseData: { base64Contents: string, id: string } = {
      base64Contents: "",
      id: ""
   }

   var params = {
      method: 'POST',
      body: JSON.stringify({
         "clientIp": "1.1.1.1",
         "clientPort": 8080,
         "captchaPurpose": "FTPMerkeziLogin"
      })
   }
 
   await fetch(
      API_URLS.CAPTCHA_GET_URL, params
   ).then(response => response.json())
      .then((textResponse) => {
         responseData = {
            base64Contents: textResponse.base64Contents,
            id: textResponse.id
         };
       
      })
      .catch((error) => {
        
      })

   return responseData;
}

export { CaptchaCallService }


